import * as React from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import './cn-tag.scss';
/**
 * @category 组件
 * @description 标签
 */
export const CnTag = (props) => {
    const { children, type, disabled } = props;
    const classes = cx({
        'cn-ui-m-tag': true,
        [`cn-ui-m-tag-${type}`]: !!type,
        'cn-ui-m-tag-disabled': !!disabled,
    });
    return withNativeProps(props, React.createElement("div", { className: classes, ...props }, children));
};
CnTag.displayName = 'CnTag';
CnTag.defaultProps = {
    type: 'normal',
};
